import { render, staticRenderFns } from "./starLevel.vue?vue&type=template&id=7be52a24&scoped=true"
import script from "./starLevel.vue?vue&type=script&lang=js"
export * from "./starLevel.vue?vue&type=script&lang=js"
import style0 from "./starLevel.vue?vue&type=style&index=0&id=7be52a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be52a24",
  null
  
)

export default component.exports